export default __webpack_public_path__ + "static/media/DAIF_Eco_Loop_Comp.ccae3199.mp4";